import React from "react";
import Slider from "react-slick";

function Latest() {
  var settings = {
    // dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          centerMode: true,
          centerPadding: "18px",
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 800,
        settings: {
          centerMode: false,
          slidesToShow: 1.5,
        },
      },
      {
        breakpoint: 600,
        settings: {
          centerMode: false,
          slidesToShow: 1.1,
        },
      },
      {
        breakpoint: 400,
        settings: {
          centerMode: false,
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="pt120">
      <div className="pb-3">
        <div className="d-flex justify-content-between align-items-center pb-4">
          <h3>latest articles</h3>
          <div>
            <button className="allbutton">See all</button>
          </div>
        </div>
        <div className="pt-3">
          {/* <div className="latestCarousel"> */}
            <Slider {...settings}>
              <div className="latestCard">
                <div className="latestImg">
                  <img src="image 32 (4).png" alt="latest" />
                </div>
                <div className="latestDsc">
                  <div>
                    Your Ultimate Guide to Getting Started With NFTs on JOLLY
                  </div>
                  <p>June 22, 2022</p>
                </div>
              </div>
              <div className="latestCard">
                <div className="latestImg">
                  <img src="image 54.png" alt="latest" />
                </div>
                <div className="latestDsc">
                  <div>
                    Your Ultimate Guide to Getting Started With NFTs on JOLLY
                  </div>
                  <p>June 22, 2022</p>
                </div>
              </div>
              <div className="latestCard">
                <div className="latestImg">
                  <img src="image 55.png" alt="latest" />
                </div>
                <div className="latestDsc">
                  <div>
                    Your Ultimate Guide to Getting Started With NFTs on JOLLY
                  </div>
                  <p>June 22, 2022</p>
                </div>
              </div>
              <div className="latestCard">
                <div className="latestImg">
                  <img src="image 32 (4).png" alt="latest" />
                </div>
                <div className="latestDsc">
                  <div>
                    Your Ultimate Guide to Getting Started With NFTs on JOLLY
                  </div>
                  <p>June 22, 2022</p>
                </div>
              </div>
            </Slider>
          {/* </div> */}
        </div>
      </div>
    </div>
  );
}

export default Latest;
